import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { styled } from "@mui/material/styles";

// Import assets
import { Images } from "../../../../utils/Images";
import { getImageSrc } from "../../../../utils/imageMapping";

// Styled components
const CardContainer = styled(Box)(({ theme, isMobile, isTablet, isSmallScreen, isMediumScreen }) => ({
  width: isMobile ? "328px" : isSmallScreen ? "330px" : isMediumScreen ? "380px" : "461px",
  height: isMobile ? "140px" : isSmallScreen ? "150px" : isMediumScreen ? "160px" : "199px",
  borderRadius: isMobile ? "11.38px" : isSmallScreen ? "12px" : "16px",
  gap: isMobile ? "8px" : isSmallScreen ? "10px" : isMediumScreen ? "12px" : "14.39px",
  opacity: 1,
  padding: isMobile ? "11.38px" : isSmallScreen ? "10px" : isMediumScreen ? "12px" : "16px",
  background: "#FFFFFF",
  boxShadow: isMobile ? "0px 2.85px 13.65px 0px #0000001A" : "0px 4px 19.18px 0px #0000001A",
  display: "flex",
  alignItems: "center",
}));

const ImageContainer = styled(Box)(({ theme, isMobile, isTablet, isSmallScreen, isMediumScreen, backgroundColor }) => ({
  width: isMobile ? "118.10845947265625px" : isSmallScreen ? "110px" : isMediumScreen ? "130px" : "166px",
  height: isMobile ? "118.81995391845703px" : isSmallScreen ? "110px" : isMediumScreen ? "130px" : "167px",
  opacity: 1,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  overflow: "hidden",
  borderRadius: isMobile ? "5.9px" : isSmallScreen ? "10px" : "12px",
  background: backgroundColor,
  "& img": {
    width: isMobile ? "80%" : "100%",
    height: isMobile ? "80%" : "100%",
    objectFit: "contain",
    borderRadius: isMobile ? "5.9px" : isSmallScreen ? "10px" : "12px",
  },
}));

const ContentContainer = styled(Box)(({ theme, isMobile }) => ({
  flex: 1,
  display: "flex",
  flexDirection: "column",
//   gap: "16px",
//   marginLeft: "16px",
}));

const Title = styled(Typography)(({ theme, isMobile, isTablet, isSmallScreen, isMediumScreen }) => ({
  fontFamily: isMobile ? "Red Hat Display" : "inherit",
  fontWeight: 700,
  fontStyle: "Bold",
  fontSize: isMobile ? "14px" : isSmallScreen ? "12px" : isMediumScreen ? "14px" : "16px",
  lineHeight: "100%",
  letterSpacing: "0%",
  color: "#1D1D1B",
  marginBottom: isMobile ? "10px" : isSmallScreen ? "8px" : isMediumScreen ? "9px" : "11px",
}));

const ProgressSection = styled(Box)(({ theme, isMobile, isTablet, isSmallScreen, isMediumScreen }) => ({
  display: "flex",
  alignItems: "center",
  gap: isMobile ? "6px" : isSmallScreen ? "8px" : isMediumScreen ? "10px" : "12px",
}));

const ProgressCircle = styled(Box)(({ theme, isMobile, isTablet, isSmallScreen, isMediumScreen, progress }) => ({
  width: isMobile ? "36px" : isSmallScreen ? "36px" : isMediumScreen ? "42px" : "52px",
  height: isMobile ? "36px" : isSmallScreen ? "36px" : isMediumScreen ? "42px" : "52px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
}));

const ProgressText = styled(Typography)(({ theme, isMobile, isTablet, isSmallScreen, isMediumScreen }) => ({
  // fontFamily: "Red Hat Display",
  fontWeight: 700,
  fontStyle: "Bold",
  fontSize: isMobile ? "8px" : isSmallScreen ? "8px" : isMediumScreen ? "10px" : "12px",
  lineHeight: "100%",
  color: "#1D1D1B",
  position: "relative",
  zIndex: 1,
}));

const ProgressInfo = styled(Box)(({ theme, isMobile, isTablet, isSmallScreen, isMediumScreen }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "2px",
}));

const ObtainedGoalText = styled(Typography)(({ theme, isMobile, isTablet, isSmallScreen, isMediumScreen }) => ({
  fontFamily: isMobile ? "Red Hat Display" : "inherit",
  fontWeight: 700,
  fontStyle: "Bold",
  fontSize: isMobile ? "10px" : isSmallScreen ? "10px" : isMediumScreen ? "12px" : "14px",
  lineHeight: "100%",
  letterSpacing: "0%",
  color: "#1D1D1B",
}));

const QuantityObtainedText = styled(Typography)(({ theme, isMobile, isTablet, isSmallScreen, isMediumScreen }) => ({
  fontFamily: isMobile ? "Red Hat Display" : "inherit",
  fontWeight: 400,
  fontStyle: "Regular",
  fontSize: isMobile ? "10px" : isSmallScreen ? "10px" : isMediumScreen ? "12px" : "14px",
  lineHeight: "100%",
  letterSpacing: "0%",
  color: "#979796",
}));

const Divider = styled(Box)(({ theme, isMobile, isTablet, isSmallScreen, isMediumScreen }) => ({
  border: "0.78px solid #BEBFD0",
  marginBottom: isMobile ? "11px" : isSmallScreen ? "10px" : isMediumScreen ? "12px" : "16px",
  marginTop: isMobile ? "11px" : isSmallScreen ? "10px" : isMediumScreen ? "12px" : "16px",
}));

const BottomSection = styled(Box)(({ theme, isMobile, isTablet, isSmallScreen, isMediumScreen }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  flex: 1,
}));

const PriceContainer = styled(Box)(({ theme, isMobile }) => ({
  display: "flex",
  alignItems: "center",
  gap: "2px",
}));

const PriceAmount = styled(Typography)(({ theme, isMobile, isTablet, isSmallScreen, isMediumScreen }) => ({
  fontFamily: isMobile ? "Red Hat Display" : "inherit",
  fontWeight: 900,
  fontStyle: "Black",
  fontSize: isMobile ? "12px" : isSmallScreen ? "14px" : isMediumScreen ? "16px" : "18px",
  lineHeight: "100%",
  letterSpacing: "-2%",
  color: "#9CBA4D",
}));

const PriceQuantity = styled(Typography)(({ theme, isMobile, isTablet, isSmallScreen, isMediumScreen }) => ({
  fontFamily: isMobile ? "Red Hat Display" : "inherit",
  fontWeight: 600,
  fontStyle: "SemiBold",
  fontSize: isMobile ? "12px" : isSmallScreen ? "14px" : isMediumScreen ? "16px" : "18px",
  lineHeight: "100%",
  letterSpacing: "-2%",
  color: "#4A4A49",
}));

const QuantitySelector = styled(Box)(({ theme, isMobile, isTablet, isSmallScreen, isMediumScreen }) => ({
  width: isMobile ? "77.55314636230469px" : isSmallScreen ? "80px" : isMediumScreen ? "90px" : "109px",
  height: isMobile ? "34.86334228515625px" : isSmallScreen ? "36px" : isMediumScreen ? "40px" : "49px",
  borderRadius: isMobile ? "6.82px" : isSmallScreen ? "8px" : isMediumScreen ? "8.5px" : "9.59px",
  paddingTop: isMobile ? "5.12px" : isSmallScreen ? "6px" : isMediumScreen ? "6.5px" : "7.19px",
  paddingRight: isMobile ? "6.82px" : isSmallScreen ? "8px" : isMediumScreen ? "8.5px" : "9.59px",
  paddingBottom: isMobile ? "5.12px" : isSmallScreen ? "6px" : isMediumScreen ? "6.5px" : "7.19px",
  paddingLeft: isMobile ? "6.82px" : isSmallScreen ? "8px" : isMediumScreen ? "8.5px" : "9.59px",
  gap: isMobile ? "11.38px" : isSmallScreen ? "10px" : isMediumScreen ? "12px" : "16px",
  opacity: 1,
  border: isMobile ? "0.85px solid #1D1D1B" : "1.2px solid #1D1D1B",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
}));

const IconButton = styled(Box)(({ theme, isMobile, isTablet, isSmallScreen, isMediumScreen }) => ({
  width: isMobile ? "12px" : isSmallScreen ? "14px" : isMediumScreen ? "16px" : "19px",
  height: isMobile ? "12px" : isSmallScreen ? "14px" : isMediumScreen ? "16px" : "19px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  "& img": {
    width: isMobile ? "12px" : isSmallScreen ? "14px" : isMediumScreen ? "16px" : "19px",
    height: isMobile ? "12px" : isSmallScreen ? "14px" : isMediumScreen ? "16px" : "19px",
  },
}));

const QuantityNumber = styled(Typography)(({ theme, isMobile, isTablet, isSmallScreen, isMediumScreen }) => ({
  // fontFamily: "Red Hat Display",
  fontWeight: 900,
  fontStyle: "Black",
  fontSize: isMobile ? "12px" : isSmallScreen ? "12px" : isMediumScreen ? "14px" : "16.79px",
  lineHeight: "100%",
  letterSpacing: "0%",
  textAlign: "center",
  color: "#1D1D1B",
}));

const ProductSmallCard = ({ productData, cardIndex }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery("(max-width: 900px)");
  const isSmallScreen = useMediaQuery("(max-width: 1200px)");
  const isMediumScreen = useMediaQuery("(max-width: 1420px)");
  const { id, title, image, price, quantity: productQuantity, goal, obtained } = productData;
  
  // Initialize quantity from sessionStorage if product is already selected
  const [quantity, setQuantity] = useState(() => {
    try {
      const selectedProducts = JSON.parse(sessionStorage.getItem("selectedProducts") || "[]");
      const existingProduct = selectedProducts.find(p => p.id === id);
      return existingProduct ? existingProduct.quantity : 0;
    } catch (error) {
      return 0;
    }
  });

  // Sync quantity when sessionStorage is updated externally (e.g. reset on page entry or back-navigation)
  useEffect(() => {
    const syncQuantity = () => {
      try {
        const selectedProducts = JSON.parse(sessionStorage.getItem("selectedProducts") || "[]");
        const existing = selectedProducts.find(p => p.id === id);
        setQuantity(existing ? existing.quantity : 0);
      } catch {
        setQuantity(0);
      }
    };
    window.addEventListener('selectedProductsUpdated', syncQuantity);
    return () => window.removeEventListener('selectedProductsUpdated', syncQuantity);
  }, [id]);
  
  const displayedObtained = obtained + quantity;
  const progressPercentage = Math.round((displayedObtained / goal) * 100);

  // Small card background colors array
  const smallCardColors = [
    "#FFF5F2", // First color
    "#E3F4F4", // Second color
    "#F0F8FF", // Light blue
    "#FFF8DC", // Light yellow
    "#F5F5DC", // Beige
    "#E6E6FA", // Lavender
    "#F0FFF0", // Honeydew
    "#FFF0F5", // Lavender blush
    "#F5FFFA", // Mint cream
    "#FFFAF0", // Floral white
  ];

  // Get background color based on card index (cycles through colors)
  const backgroundColor = smallCardColors[cardIndex % smallCardColors.length];

  // Helper function to update selected products in sessionStorage
  const updateSelectedProducts = (newQuantity) => {
    try {
      const selectedProducts = JSON.parse(sessionStorage.getItem("selectedProducts") || "[]");
      const productIndex = selectedProducts.findIndex(p => p.id === id);
      
      if (newQuantity > 0) {
        const productData = {
          id,
          title,
          image: getImageSrc(image),
          price,
          quantity: newQuantity,
          totalAmount: price * newQuantity
        };
        
        if (productIndex >= 0) {
          selectedProducts[productIndex] = productData;
        } else {
          selectedProducts.push(productData);
        }
      } else {
        // Remove product if quantity is 0
        if (productIndex >= 0) {
          selectedProducts.splice(productIndex, 1);
        }
      }
      
      sessionStorage.setItem("selectedProducts", JSON.stringify(selectedProducts));
      
      // Update count for backward compatibility
      const totalCount = selectedProducts.reduce((sum, p) => sum + p.quantity, 0);
      sessionStorage.setItem("selectedProductsCount", String(totalCount));
      
      // Trigger storage event for real-time updates
      window.dispatchEvent(new Event('storage'));
      window.dispatchEvent(new CustomEvent('selectedProductsUpdated'));
    } catch (error) {
      console.error("Error updating selected products:", error);
    }
  };

  const handleIncreaseQuantity = () => {
    const newQuantity = quantity + 1;
    setQuantity(newQuantity);
    updateSelectedProducts(newQuantity);
  };

  const handleDecreaseQuantity = () => {
    if (quantity > 0) {
      const newQuantity = quantity - 1;
      setQuantity(newQuantity);
      updateSelectedProducts(newQuantity);
    }
  };

  // Calculate responsive SVG dimensions
  const svgSize = isMobile ? 36 : isSmallScreen ? 36 : isMediumScreen ? 42 : 52;
  const circleRadius = isMobile ? 14 : isSmallScreen ? 15 : isMediumScreen ? 18 : 22;
  const strokeWidth = isMobile ? 2 : isSmallScreen ? 2 : isMediumScreen ? 2.5 : 3;

  return (
    <CardContainer isMobile={isMobile} isTablet={isTablet} isSmallScreen={isSmallScreen} isMediumScreen={isMediumScreen}>
      {/* Image Section */}
      <ImageContainer isMobile={isMobile} isTablet={isTablet} isSmallScreen={isSmallScreen} isMediumScreen={isMediumScreen} backgroundColor={backgroundColor}>
        <img src={getImageSrc(image)} alt={title} />
      </ImageContainer>

      {/* Content Section */}
      <ContentContainer isMobile={isMobile}>
        {/* Title */}
        <Title isMobile={isMobile} isTablet={isTablet} isSmallScreen={isSmallScreen} isMediumScreen={isMediumScreen}>
          {title}
        </Title>

         {/* Progress Section */}
         <ProgressSection isMobile={isMobile} isTablet={isTablet} isSmallScreen={isSmallScreen} isMediumScreen={isMediumScreen}>
           <ProgressCircle isMobile={isMobile} isTablet={isTablet} isSmallScreen={isSmallScreen} isMediumScreen={isMediumScreen} progress={progressPercentage}>
             <svg
               width={svgSize}
               height={svgSize}
               viewBox={`0 0 ${svgSize} ${svgSize}`}
               style={{ position: "absolute", top: 0, left: 0 }}
             >
               {/* Background circle */}
               <circle
                 cx={svgSize/2}
                 cy={svgSize/2}
                 r={circleRadius}
                 fill="none"
                 stroke="#E8E8E8"
                 strokeWidth={strokeWidth}
               />
               {/* Progress circle */}
               <circle
                 cx={svgSize/2}
                 cy={svgSize/2}
                 r={circleRadius}
                 fill="none"
                 stroke="#29CC6A"
                 strokeWidth={strokeWidth}
                 strokeLinecap="round"
                 strokeDasharray={`${2 * Math.PI * circleRadius}`}
                 strokeDashoffset={`${2 * Math.PI * circleRadius * (1 - progressPercentage / 100)}`}
                 transform={`rotate(-90 ${svgSize/2} ${svgSize/2})`}
                 style={{
                   transition: "stroke-dashoffset 0.3s ease",
                 }}
               />
             </svg>
             <ProgressText isMobile={isMobile} isTablet={isTablet} isSmallScreen={isSmallScreen} isMediumScreen={isMediumScreen}>
               {progressPercentage}%
             </ProgressText>
           </ProgressCircle>
           <ProgressInfo isMobile={isMobile} isTablet={isTablet} isSmallScreen={isSmallScreen} isMediumScreen={isMediumScreen}>
             <ObtainedGoalText isMobile={isMobile} isTablet={isTablet} isSmallScreen={isSmallScreen} isMediumScreen={isMediumScreen}>
              {displayedObtained} of {goal}
             </ObtainedGoalText>
             <QuantityObtainedText isMobile={isMobile} isTablet={isTablet} isSmallScreen={isSmallScreen} isMediumScreen={isMediumScreen}>
               Quantity Obtained
             </QuantityObtainedText>
           </ProgressInfo>
         </ProgressSection>

        {/* Divider */}
        <Divider isMobile={isMobile} isTablet={isTablet} isSmallScreen={isSmallScreen} isMediumScreen={isMediumScreen} />

         {/* Bottom Section */}
         <BottomSection isMobile={isMobile} isTablet={isTablet} isSmallScreen={isSmallScreen} isMediumScreen={isMediumScreen}>
           {/* Price Container */}
           <PriceContainer isMobile={isMobile}>
             <PriceAmount isMobile={isMobile} isTablet={isTablet} isSmallScreen={isSmallScreen} isMediumScreen={isMediumScreen}>
               ₹{price}
             </PriceAmount>
             <PriceQuantity isMobile={isMobile} isTablet={isTablet} isSmallScreen={isSmallScreen} isMediumScreen={isMediumScreen}>
               /{productQuantity}
             </PriceQuantity>
           </PriceContainer>

           {/* Quantity Selector */}
           <QuantitySelector isMobile={isMobile} isTablet={isTablet} isSmallScreen={isSmallScreen} isMediumScreen={isMediumScreen}>
             <IconButton 
               isMobile={isMobile} 
               isTablet={isTablet} 
               isSmallScreen={isSmallScreen} 
               isMediumScreen={isMediumScreen}
               onClick={handleDecreaseQuantity}
             >
               <img src={Images.pminus} alt="Decrease" />
             </IconButton>
             <QuantityNumber isMobile={isMobile} isTablet={isTablet} isSmallScreen={isSmallScreen} isMediumScreen={isMediumScreen}>
              {quantity.toString()}
             </QuantityNumber>
             <IconButton 
               isMobile={isMobile} 
               isTablet={isTablet} 
               isSmallScreen={isSmallScreen} 
               isMediumScreen={isMediumScreen}
               onClick={handleIncreaseQuantity}
             >
               <img src={Images.pplus} alt="Increase" />
             </IconButton>
           </QuantitySelector>
         </BottomSection>
      </ContentContainer>
    </CardContainer>
  );
};

export default ProductSmallCard;
